/* ============
 * Recipe Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class BatchIngredienceTransformer extends Transformer {

  static fetch(batchIngredience) {
    return {
      id: batchIngredience.id,
      batchId: batchIngredience.batch_id,
      batch: batchIngredience.batch,
      recipeId: batchIngredience.recipe_id,
      recipe: batchIngredience.recipe,
      materialId: batchIngredience.material_id,
      materialName: batchIngredience.material_name,
      materialType: batchIngredience.material_type,
      unitMeasure: batchIngredience.unit_measure,
      amount: batchIngredience.amount,
      deductedAmount: batchIngredience.deducted_amount,
    };
  }

  static send(batchIngredience) {
    return {
      id: batchIngredience.id,
      batch_id: batchIngredience.batchId,
      recipe_id: batchIngredience.recipeId,
      material_id: batchIngredience.materialId,
      amount: batchIngredience.amount,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/batchIngredience.js